export const SET_UTM_PARAMS = 'SET_UTM_PARAMS';
export const CLEAR_UTM_PARAMS = 'CLEAR_UTM_PARAMS';
